import type { SelectOption } from './types'

/**
 * Normalizes select text before search and typeahead comparisons.
 */
export const normalizeSelectText = (value: string) => value.trim().toLocaleLowerCase('und')

/**
 * Returns the option matching the controlled value, if one is present.
 */
export const findSelectedOption = (options: SelectOption[], value: string) =>
  options.find((option) => option.value === value)

/**
 * Filters options by label, secondary label, or value using locale-stable text
 * normalization.
 */
export const filterSelectOptions = (options: SelectOption[], query: string) => {
  const normalizedQuery = normalizeSelectText(query)
  if (!normalizedQuery) return options

  return options.filter((option) => {
    const normalizedLabel = normalizeSelectText(option.label)
    const normalizedSecondaryLabel = normalizeSelectText(option.secondaryLabel ?? '')
    const normalizedValue = normalizeSelectText(option.value)
    return (
      normalizedLabel.includes(normalizedQuery) ||
      normalizedSecondaryLabel.includes(normalizedQuery) ||
      normalizedValue.includes(normalizedQuery)
    )
  })
}

